
import { Component, Prop, Element, State, Watch, h } from '@stencil/core';
import { DataIn } from './weather-interface';

@Component({
  tag: 'lar-weather-content',
  shadow: true,
  styleUrl: 'weather.scss',
})
export class WeatherContent {
  /**
   * Component JSON text
   */
  @Prop() data?: DataIn | string;

  @State() parsedData: DataIn = {};

  componentWillLoad() {
    this.parseData();
  }

  @Watch('data')
  parseData() {
    if (typeof this.data === 'string') {
      try {
        this.parsedData = JSON.parse(this.data);
      } catch (e) {
        console.error('Failed to parse weather data:', e);
        this.parsedData = {};
      }
    } else {
      this.parsedData = this.data || {};
    }
  }

  render() {
    return [
      <div class="suninfo">
        {this.parsedData.sunrise && <div class="sunrise"><lar-icon size="large" icon="wi-sunrise" /><span>{this.parsedData.sunrise}</span></div>}
        {this.parsedData.sunset && <div class="sunset"><lar-icon size="large" icon="wi-sunset" /><span>{this.parsedData.sunset}</span></div>}
      </div>,
      <lar-list class="detailinfo">
        {this.parsedData.temperature !== undefined && <lar-weather-item icon="wi-thermometer-exterior" name="weather.temperature" value={`${this.parsedData.temperature}°`} />}
        {this.parsedData.temperatureFeelsLike !== undefined && <lar-weather-item icon="wi-thermometer-exterior" name="weather.temperatureFeelsLike" value={`${this.parsedData.temperatureFeelsLike}°`} />}
        {this.parsedData.drewPoint !== undefined && <lar-weather-item icon="wi-raindrop" name="weather.drewPoint" value={`${this.parsedData.drewPoint}°`} />}
        {this.parsedData.solarIrradiation !== undefined && <lar-weather-item icon="wi-day-sunny" name="weather.solarIrradiation" value={`${this.parsedData.solarIrradiation}%`} />}
        {this.parsedData.windSpeed !== undefined && <lar-weather-item icon="wi-strong-wind" name="weather.windSpeed" value={`${this.parsedData.windSpeed}m/s`} />}
        {this.parsedData.windDirection !== undefined && <lar-weather-item icon="wi-wind-deg" name="weather.windDirection" rotateIcon={this.parsedData.windDirection} value={`${this.parsedData.windDirection}°`} />}
        {this.parsedData.daylight !== undefined && typeof this.parsedData.daylight === 'number' && <lar-weather-item icon="wi-day-sunny" name="weather.daylight" value={`${this.parsedData.daylight}lx`} />}
        {this.parsedData.daylight !== undefined && typeof this.parsedData.daylight === 'boolean' && <lar-weather-item icon="wi-day-sunny" name="weather.daylight" value={`${this.parsedData.daylight}`} />}
        {this.parsedData.humidity !== undefined && <lar-weather-item icon="wi-humidity" name="weather.humidity" value={`${this.parsedData.humidity}%`} />}
        {this.parsedData.pressure !== undefined && <lar-weather-item icon="wi-barometer" name="weather.pressure" value={`${this.parsedData.pressure}hPa`} />}
        {this.parsedData.rain !== undefined && typeof this.parsedData.rain === 'number' && <lar-weather-item icon="wi-raindrops" name="weather.rain" value={`${this.parsedData.rain}mm`} />}
        {this.parsedData.rain !== undefined && typeof this.parsedData.rain === 'boolean' && <lar-weather-item icon="wi-raindrops" name="weather.rain" value={`${this.parsedData.rain}`} />}
        {this.parsedData.snow !== undefined && typeof this.parsedData.snow === 'number' && <lar-weather-item icon="wi-snow" name="weather.snow" value={`${this.parsedData.snow}mm`} />}
        {this.parsedData.snow !== undefined && typeof this.parsedData.snow === 'boolean' && <lar-weather-item icon="wi-snow" name="weather.snow" value={`${this.parsedData.snow}`} />}
        {this.parsedData.storm !== undefined && <lar-weather-item icon="wi-storm-warning" name="weather.storm" value={`${this.parsedData.storm}`} />}
        {this.parsedData.fog !== undefined && <lar-weather-item icon="wi-fog" name="weather.fog" value={`${this.parsedData.fog}`} />}
      </lar-list>
    ];
  }
}